// Emisión y renovación de las CloudFront signed cookies que autorizan /docs/*.
//
// Las cookies son HttpOnly: JavaScript no puede leerlas ni verificar su vigencia.
// Por eso el endpoint devuelve expiresAt y acá se programa la renovación.

const ENDPOINT = '/api/docs-session';
const RENEW_MARGIN_MS = 5 * 60 * 1000; // renovar 5 min antes de vencer

let renewTimer = null;
let inFlight = null;

/**
 * Pide las cookies de documentos. El browser las guarda solo, a partir de los
 * headers Set-Cookie; acá únicamente se lee expiresAt para reprogramar.
 * Devuelve true si quedaron emitidas.
 */
export async function ensureDocsSession(getAccessTokenSilently) {
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const token = await getAccessTokenSilently();
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        console.warn(`docsSession: endpoint respondió ${res.status}; los PDF no van a abrir`);
        return false;
      }

      const { expiresAt } = await res.json();
      scheduleRenewal(expiresAt, getAccessTokenSilently);
      return true;
    } catch (err) {
      console.warn('docsSession: no se pudieron emitir las credenciales de documentos:', err);
      return false;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}

function scheduleRenewal(expiresAt, getAccessTokenSilently) {
  if (!expiresAt) return;
  if (renewTimer) clearTimeout(renewTimer);

  const delay = expiresAt * 1000 - Date.now() - RENEW_MARGIN_MS;
  // setTimeout desborda arriba de ~24.8 días; el TTL real es de horas.
  renewTimer = setTimeout(
    () => ensureDocsSession(getAccessTokenSilently),
    Math.max(delay, 60 * 1000)
  );
}
